{
  "hero.title": "מחליף סביבות לכמה כלי CLI",
  "hero.tagline-1": "להיכנס לזרימה רגועה בזמן תכנות.",
  "hero.tagline-2": "מעבר חלק בין סביבות.",
  "hero.subtitle": "ניהול אחיד של תצורות Claude Code, Codex ו-OpenCode, עם מעבר אוטומטי לגיבוי בפרוקסי ה-API",
  "hero.getDocs": "תיעוד",
  "features.title": "יכולות",
  "features.multiCli.title": "תמיכה בכמה כלי CLI",
  "features.multiCli.desc": "תמיכה ב-Claude Code, Codex ו-OpenCode עם הגדרה לכל פרויקט",
  "features.multiConfig.title": "ניהול תצורה",
  "features.multiConfig.desc": "כל תצורות ספקי ה-API בקובץ JSON אחד",
  "features.daemon.title": "דימון אחד",
  "features.daemon.desc": "תהליך zend יחיד מריץ גם את שרת הפרוקסי וגם את ממשק הווב",
  "features.failover.title": "מעבר לגיבוי בפרוקסי",
  "features.failover.desc": "פרוקסי HTTP מובנה שעובר אוטומטית לגיבוי כשהספק הראשי אינו זמין",
  "features.routing.title": "ניתוב לפי תרחיש",
  "features.routing.desc": "ניתוב חכם לפי מאפייני הבקשה (חשיבה, תמונה ועוד)",
  "features.binding.title": "קישור פרויקטים",
  "features.binding.desc": "קשרו תיקיות לפרופילים ולכלי CLI מסוימים להגדרה אוטומטית ברמת הפרויקט",
  "features.envVars.title": "משתני סביבה",
  "features.envVars.desc": "הגדירו משתני סביבה לכל כלי CLI ברמת הספק",
  "features.webUi.title": "ממשק ווב",
  "features.webUi.desc": "ניהול חזותי בדפדפן, מוגן בסיסמה",
  "features.webSecurity.title": "אבטחת ממשק הווב",
  "features.webSecurity.desc": "סיסמה שנוצרת אוטומטית, אימות מבוסס סשן והצפנת RSA להעברת אסימונים",
  "features.configSync.title": "סנכרון תצורה",
  "features.configSync.desc": "סנכרון ספקים, פרופילים והגדרות בין מכשירים בהצפנת AES-256-GCM",
  "features.comingSoon": "יכולות נוספות בדרך, הישארו מעודכנים!",
  "install.title": "התחלה מהירה",
  "install.step1.title": "התקנת GoZen",
  "install.step1.desc": "סקריפט התקנה בשורה אחת",
  "install.step2.title": "הגדרת ספק",
  "install.step2.desc": "הוסיפו את ספק ה-API הראשון",
  "install.step3.title": "הפעלה",
  "install.step3.desc": "הריצו את ה-CLI עם תצורת ברירת המחדל",
  "commands.title": "פקודות",
  "commands.command": "פקודה",
  "commands.description": "תיאור",
  "commands.items.start": "הפעלת ה-CLI (לפי קישור הפרויקט או תצורת ברירת המחדל)",
  "commands.items.profile": "הפעלה עם פרופיל מסוים",
  "commands.items.profilePick": "בחירת פרופיל אינטראקטיבית",
  "commands.items.cli": "שימוש בכלי CLI מסוים (claude/codex/opencode)",
  "commands.items.yes": "אישור אוטומטי של הרשאות ה-CLI‏ (claude --permission-mode acceptEdits, codex -a never)",
  "commands.items.use": "שימוש ישיר בספק מסוים (ללא פרוקסי)",
  "commands.items.pick": "בחירת ספק אינטראקטיבית",
  "commands.items.list": "הצגת כל הספקים והפרופילים",
  "commands.items.configAddProvider": "הוספת ספק חדש",
  "commands.items.configAddProfile": "הוספת פרופיל חדש",
  "commands.items.configDefaultClient": "קביעת כלי ה-CLI שברירת המחדל",
  "commands.items.configDefaultProfile": "קביעת פרופיל ברירת המחדל",
  "commands.items.configResetPassword": "איפוס הסיסמה של ממשק הווב",
  "commands.items.configSync": "משיכת התצורה משירות הסנכרון",
  "commands.items.daemonStart": "הפעלת הדימון zend",
  "commands.items.daemonStop": "עצירת הדימון",
  "commands.items.daemonStatus": "הצגת מצב הדימון",
  "commands.items.daemonEnable": "התקנת הדימון כשירות מערכת",
  "commands.items.daemonDisable": "הסרת שירות המערכת של הדימון",
  "commands.items.bind": "קישור התיקייה הנוכחית לפרופיל",
  "commands.items.bindCli": "קישור התיקייה הנוכחית לכלי CLI מסוים",
  "commands.items.unbind": "ביטול הקישור של התיקייה הנוכחית",
  "commands.items.status": "הצגת מצב הקישור של התיקייה הנוכחית",
  "commands.items.web": "פתיחת ממשק הווב בדפדפן (מפעיל את הדימון)",
  "commands.items.upgrade": "שדרוג לגרסה האחרונה",
  "commands.items.version": "הצגת הגרסה",
  "commands.items.completion": "יצירת השלמה אוטומטית למעטפת (zsh/bash/fish)",
  "homepage.title": "מחליף סביבות לכמה כלי CLI"
}
